<template>
<svg :width="width" :height="height" viewBox="0 0 18 20" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M2.9287 8.0737L9.3469 1.65555L13.2787 1.0946L16.5828 4.3987L16.0218 8.3305L5.496 18.8563L2.3986 18.5829L1.13031 17.3147L1.04046 14.4008L10.9245 4.5168L12.7883 4.4552L13.2222 4.889L13.1606 6.7529L4.2393 15.6742" stroke="#008FD1" stroke-opacity="0.3" stroke-:width="2"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 18 },
        height: { type: [Number, String], default: 20 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
